import PageShell from "@/components/PageShell";
import Hero from "@/components/Hero";
import WhatYouKnowNextSteps from "@/components/WhatYouKnowNextSteps";
import NovatedLeaseCalculator from "@/components/NovatedLeaseCalculator";
import LatestNews from "@/components/LatestNews";

export default function Home() {
    return (
        <PageShell testId="payme-app">
            <main id="main">
                <Hero />
                <WhatYouKnowNextSteps />
                <NovatedLeaseCalculator />
                <LatestNews />
            </main>
        </PageShell>
    );
}
